import { DirectusNewsBlock } from 'config';
import { NewsBlockProps } from '../../../components/NewsBlock';
import { mapDirectusImage, mapDirectusCTAs } from '../general';
import websiteContent from 'config/xumo-website-output.json';
import { mapDirectusFooter } from './FooterMapping';

export const mapDirectusNewsBlock = (gallery: DirectusNewsBlock): NewsBlockProps => {
  const stories = [...websiteContent.press, ...websiteContent.links]
    .sort((a, b) => {
      const dateA = a.date_posted || a.date;
      const dateB = b.date_posted || b.date;

      return new Date(dateA) > new Date(dateB) ? -1 : 1;
    })
    .filter(story => {
      const galleryTagSet = new Set((gallery.tags || []).map(tag => tag.toLowerCase()));

      const storyHasB2C = story.tags?.some(tag => tag.toLowerCase() === 'b2c');
      const galleryHasB2C = galleryTagSet.has('b2c');

      // Hide B2C stories from non-B2C galleries - B2C will be excluded from /press page
      if (storyHasB2C && !galleryHasB2C) {
        return false;
      }

      if (!gallery.tags?.length) return true;

      return story.tags?.some(item => galleryTagSet.has(item.toLowerCase()));
    })
    .slice(0, gallery.max_items)
    .map(news => ({
      ...news,
      date: news.date_posted || news.date,
      thumbnail: mapDirectusImage(news.thumbnail),
    }));

  /* console.log('LET ALL STORIES?', !gallery.tags?.length);
  console.log('NUM STORIES', [...websiteContent.press, ...websiteContent.links].length);
  console.log(
    'HERE ARE TEH STORIES',
    [...websiteContent.press, ...websiteContent.links]
      .sort((a, b) => (new Date(a.date) > new Date(b.date) ? -1 : 1))
      .map(story => story.title + ' ' + story.date)
      .join('\n'),
  );
  console.log('FOR THIS BLOCK', stories.map(JSON.stringify)); */

  return {
    heading: gallery.heading,
    body: gallery.body,
    cta: gallery.cta?.length ? mapDirectusCTAs(gallery.cta, null, true) : undefined,
    tags: gallery.tags,
    stories,
    background_color: gallery.background_color,
    accent_color: gallery.accent_color,
    section_padding: gallery.section_padding,
  };
};

export const mapDirectusPressBlock = (press): NewsBlockProps => ({
  title: press.title,
  date: press.date_posted || press.date,
  description: press.description,
  content: press.content,
  tags: press.tags,
  thumbnail: mapDirectusImage(press.thumbnail),
  hide_thumbnail: press.hide_thumbnail || false,
  additionalImages: (press as any)?.additional_images?.map((image: any) => mapDirectusImage(image.directus_files_id)),
  article_content: press?.article_content,
  after_2026_q1_update: press?.after_2026_q1_update,
  sidebar_similar_content: press?.similar_content.map((item: any, id: number) => {
    return {
      title: item?.related_news_items_id?.title,
      description: item?.related_news_items_id?.description,
      thumbnail: mapDirectusImage(item?.related_news_items_id?.thumbnail),
    };
  }),
  sidebar_featured_resource: press?.featured_resource,
  sidebar_featured_resource_image: mapDirectusImage(press?.featured_resource_image),
  sidebar_form: press?.form,
  hero_full_width_image: press.hero_full_width_image,
  image_description: press.image_description,
  footer: mapDirectusFooter(websiteContent.footer),
});
